import React from 'react';
import { Button } from './Button';
import { format } from 'date-fns';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  backupInfo?: {
    created_at: string;
    backup_type: string;
    question_count: number;
    quiz_title: string;
  };
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
  backupInfo
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70]">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden">
        <div className="p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Delete Backup
          </h2>
          
          {backupInfo && (
            <div className="bg-gray-50 rounded p-4 mb-4">
              <p className="text-sm text-gray-600 mb-2">
                <span className="font-medium">Quiz:</span> {backupInfo.quiz_title}
              </p>
              <p className="text-sm text-gray-600 mb-2">
                <span className="font-medium">Created:</span> {format(new Date(backupInfo.created_at), 'PPp')}
              </p>
              <p className="text-sm text-gray-600 mb-2">
                <span className="font-medium">Type:</span> <span className="capitalize">{backupInfo.backup_type}</span>
              </p>
              <p className="text-sm text-gray-600">
                <span className="font-medium">Questions:</span> {backupInfo.question_count}
              </p>
            </div>
          )}

          <p className="text-red-600 text-sm mb-6">
            This action cannot be undone. This backup will be permanently deleted.
          </p>

          <div className="flex justify-end gap-3">
            <Button
              onClick={onClose}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2"
              disabled={isDeleting}
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2"
              disabled={isDeleting}
            >
              {isDeleting ? (
                <div className="flex items-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Deleting...
                </div>
              ) : (
                'Delete Backup'
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}; 